// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* You can add global styles to this file, and also import other style files */
body {
  padding: 2rem;
}
#steps {
  position: relative;
}
#steps > * {
  left: -20000px;
  position: absolute;
}
#steps > .active {
  left: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,8EAA8E;AAC9E;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,OAAO;AACT","sourcesContent":["/* You can add global styles to this file, and also import other style files */\nbody {\n  padding: 2rem;\n}\n#steps {\n  position: relative;\n}\n#steps > * {\n  left: -20000px;\n  position: absolute;\n}\n#steps > .active {\n  left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
